/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
import { Avatar, Col, Row } from 'antd';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ChorkiBotLogo from '../../../../assets/chorki_bot.svg';

import {
  setChatbotModalOpen,
  setChatbotTextMessageDisabled,
  setIsSearchButton,
  commonState,
  setMyProfileModal,
} from '../../../../app/base/commonSlice';
import { Translate } from '../../../ui';
// import {
//   setModalOpen,
//   setChatPage,
//   setConversation,
//   setSocketResponse,
//   setChatHistory,
// } from '../../redux/chatbotSlice';

interface ChatbotMessageProps {
  data: any;
  handleQuesId?: (id: number | undefined) => void;
}

function ChatbotMessage({ data, handleQuesId }: ChatbotMessageProps) {
  const dispatch = useDispatch();
  const { language } = useSelector(commonState);

  const handleQuesClick = (id: number | undefined, message: string) => {
    if (id !== undefined) {
      // emitRequest({ question_id: id });
      if (handleQuesId) {
        handleQuesId(id);
      }
      if (message === 'Find a colleague' || message === 'Leave a message') {
        dispatch(setChatbotTextMessageDisabled(false));
      } else {
        dispatch(setChatbotTextMessageDisabled(true));
      }
      if (message === 'Find a colleague') {
        dispatch(setIsSearchButton(true));
      } else {
        dispatch(setIsSearchButton(false));
      }
    }
  };

  const handleActionClick = () => {
    // if (action === 'ProfileModal') {
    dispatch(setMyProfileModal(true));
    dispatch(setChatbotModalOpen(false));
    // }
  };

  const navigate = useNavigate();

  const handleLinkClick = (path: string) => {
    navigate(path);
    dispatch(setChatbotModalOpen(false));
  };

  // console.log('Chatbot Message', data);

  return (
    <div className="flex gap-4 chat mt-8">
      <div>
        <Avatar className="border-inherit p-1 bg-white" src={ChorkiBotLogo} />
      </div>

      <div className="p-6 rounded-md bg-[#ECECEC] dark:bg-[#1D1D1D]">
        <Row className="gap-8">
          {data?.map((item: any) =>
            item?.answer_type === 'BUTTON' ? (
              <Col
                onClick={() => handleQuesClick(item?.id, item?.msg_contents_en)}
                key={item?.id}
                span={11}
                className="cursor-pointer bg-[#EB3E8E] text-white text-center border-1 rounded-none p-4"
              >
                {language === 'en'
                  ? item?.msg_contents_en
                  : item?.msg_contents_bn}
              </Col>
            ) : item?.answer_type === 'PATH' ? (
              <div
                onClick={() => handleLinkClick(item?.routing_path)}
                // className="cursor-pointer"
                // dangerouslySetInnerHTML={{
                //   __html:
                //     language === 'en'
                //       ? item?.msg_contents_en
                //       : item?.msg_contents_bn,
                // }}
              >
                <Translate
                  en={item?.msg_contents_en}
                  bn={item?.msg_contents_bn}
                />
              </div>
            ) : item?.answer_type === 'ACTION' ? (
              <div onClick={() => handleActionClick()}>
                <Translate
                  en={item?.msg_contents_en}
                  bn={item?.msg_contents_bn}
                />
              </div>
            ) : item?.answer_type === 'HTML' ? (
              <div>
                <Translate
                  en={item?.msg_contents_en}
                  bn={item?.msg_contents_bn}
                />
              </div>
            ) : item?.answer_type === 'TEXT' ? (
              <div>
                <Translate
                  en={item?.msg_contents_en}
                  bn={item?.msg_contents_bn}
                />
              </div>
            ) : (
              <div>{item?.msg_contents}</div>
            )
          )}
        </Row>
      </div>
    </div>
  );
}

export default ChatbotMessage;
